module.exports = __webpack_public_path__ + "img/image_route-95475776.png";